<template>

    <renderReelFacebook
        v-if="typeNetworkSelected == 'facebook' && formData.formDataNetwork.facebook.typeMedia == 'video' && formData.formDataNetwork.facebook.isReel" 
        :medias="filesNetwork" 
        :pages="pagesEdited"
        @clickPage="clickPageInRenderPost"
        @featurePage="featurePageInRenderPost"
        :musicName="null"
        :description="textContentConverted"
        :modes="modes"
        :mentions = "mentions"
        :positionFormOverlay="positionFormOverlay"
        :place="place"
        :personsIdentified="personsIdentified"
        :collaborators="collaborators"
    />

    <renderPostFacebook
        v-else-if="typeNetworkSelected == 'facebook'" 
        :medias="filesNetwork" 
        :pages="pagesEdited"
        @clickPage="clickPageInRenderPost"
        @featurePage="featurePageInRenderPost"
        :text="textContentConverted"
        :comments="commentsConverted"
        :datePost="datePost"
        :modes="modes"
        :snippet="snippet"
        :mentions = "mentions"
        :place="place"
        :positionFormOverlay="positionFormOverlay"
    />

    <renderReelInstagram
        v-else-if="
            typeNetworkSelected == 'instagram' && 
            filesNetwork.length == 1 && 
            filesNetwork[0].info.type.startsWith('video/')
        "
        :medias="filesNetwork" 
        :pages="pagesEdited"
        @clickPage="clickPageInRenderPost"
        @featurePage="featurePageInRenderPost"
        :music="music"
        :description="textContentConverted"
        :modes="modes"
        :mentions = "mentions"
        :positionFormOverlay="positionFormOverlay"
        :place="place"
        :personsIdentified="personsIdentified"
        :collaborators="collaborators"
        :products="products"
    />

    <renderPostInstagram
        v-else-if="typeNetworkSelected == 'instagram'" 
        :medias="filesNetwork" 
        :pages="pagesEdited"
        @clickPage="clickPageInRenderPost"
        @featurePage="featurePageInRenderPost"
        :text="textContentConverted"
        :comments="commentsConverted"
        :datePost="datePost"
        :modes="modes"
        :personsIdentified="personsIdentified"
        :collaborators="collaborators"
        :music="music"
        :place="place"
        :ratio="ratio"
        :mentions="mentions"
        :products="products"
        :positionFormOverlay="positionFormOverlay"
    />
    <renderPostLinkedin
        v-else-if="typeNetworkSelected == 'linkedin'" 
        :medias="filesNetwork" 
        :survey="survey"
        :files="files"
        :pages="pagesEdited"
        @clickPage="clickPageInRenderPost"
        @featurePage="featurePageInRenderPost"
        :text="textContentConverted"
        :comments="commentsConverted"
        :datePost="datePost"
        :snippet="snippet"
        :mentions = "mentions"
    />

    <renderPostThreads
        v-else-if="typeNetworkSelected == 'threads'" 
        :medias="filesNetwork"
        :pages="pagesEdited"
        @clickPage="clickPageInRenderPost"
        @featurePage="featurePageInRenderPost"
        :text="textContentConverted"
        :comments="commentsConverted"
        :datePost="datePost"
        :snippet="snippet"
        :mentions="mentions"
    />

    <renderPostTwitter
        v-else-if="typeNetworkSelected == 'twitter'" 
        :medias="filesNetwork" 
        :pages="pagesEdited"
        @clickPage="clickPageInRenderPost"
        @featurePage="featurePageInRenderPost"
        :text="textContentConverted"
        :comments="commentsConverted"
        :datePost="datePost"
        :snippet="snippet"
        :mentions = "mentions"
        :verifiedMode = "pages.every(page => page.story_config && page.story_config.verified_type !== 'none')"
        :tweetSplitting="formData.formDataNetwork.twitter.tweetSplitting ? formData.formDataNetwork.twitter.tweetSplitting.active : false" 
    />

    <renderPostBluesky
        v-else-if="typeNetworkSelected == 'bluesky'" 
        :medias="filesNetwork" 
        :pages="pagesEdited"
        @clickPage="clickPageInRenderPost"
        @featurePage="featurePageInRenderPost"
        :text="textContentConverted"
        :comments="commentsConverted"
        :datePost="datePost"
        :snippet="snippet"
        :mentions = "mentions"
    />

    <renderPostTiktok
        v-else-if="typeNetworkSelected == 'tiktok'"
        :medias="filesNetwork"
        :pages="pagesEdited"
        @clickPage="clickPageInRenderPost"
        @featurePage="featurePageInRenderPost"
        :title="textContentConverted ? Array.from(textContentConverted).slice(0, 90).join('').split(/<br\s*\/?>|<\/br>|\n/i)[0] : undefined"
        :text="textContentConverted ? Array.from(textContentConverted.split(/<br\s*\/?>|<\/br>|\n/i).slice(1).join('\n')).slice(0, 4000).join('') : undefined"
        :mentions="mentions"
        :modes="modes"
        :music="music"
        :positionFormOverlay="positionFormOverlay"
    />

    <renderPostGoogle v-else-if="typeNetworkSelected == 'google'" 
        :medias="filesNetwork" 
        :pages="pagesEdited"
        @clickPage="clickPageInRenderPost"
        @featurePage="featurePageInRenderPost"
        :text="textContentConverted"
        :datePost="datePost"
        :snippet="snippet"
        :mentions = "mentions"
    />

    <renderPostTelegram
        v-else-if="typeNetworkSelected == 'telegram'" 
        :medias="filesNetwork"  
        :pages="pagesEdited"
        @clickPage="clickPageInRenderPost"
        @featurePage="featurePageInRenderPost"
        :text="textContentConverted"
        :comments="commentsConverted"
        :datePost="datePost"
        :snippet="snippet"
        :mentions = "mentions"
    />

    <renderPostPinterest
        v-else-if="typeNetworkSelected == 'pinterest'" 
        :medias="filesNetwork" 
        :pages="pagesEdited"
        @clickPage="clickPageInRenderPost"
        @featurePage="featurePageInRenderPost"
        :title="textContentConverted ? Array.from(textContentConverted.split(/<br\s*\/?>|<\/br>|\n/i)[0]).slice(0, 100).join('') : undefined"
        :text="textContentConverted ? textContentConverted.split(/<br\s*\/?>|<\/br>|\n/i).slice(1).join('\n') : undefined"
        :datePost="datePost"
        :snippet="snippet"
        :mentions="mentions"
    />

    <renderShortYoutube 
        v-else-if="typeNetworkSelected == 'youtube' && (!filesNetwork.length || filesNetwork[0].info.aspectRatio == 0.5625)" 
        :medias="filesNetwork" 
        :pages="pagesEdited"
        @clickPage="clickPageInRenderPost"
        @featurePage="featurePageInRenderPost"
        :musicName="null"
        :description="textContentConverted"
        :mentions = "mentions"
    />

    <renderPostYoutube
        v-else-if="typeNetworkSelected == 'youtube'" 
        :medias="filesNetwork" 
        :pages="pagesEdited"
        @clickPage="clickPageInRenderPost"
        @featurePage="featurePageInRenderPost"
        :title="textContentConverted ? Array.from(textContentConverted).slice(0, 100).join('').split(/<br\s*\/?>|<\/br>|\n/i)[0] : undefined"
        :text="textContentConverted ? textContentConverted.split(/<br\s*\/?>|<\/br>|\n/i).slice(1).join('\n') : undefined"
        :comments="commentsConverted" 
        :datePost="datePost"
        :mentions = "mentions"
    />
</template>


<script>
    import { listNetworkSort } from './../../constante.js'
    import {
        getFilesByNetwork,
        mergeUpdates,
        getFeaturedPage
    } from './../../utils.js'
    import { resolveVariables } from '@/utils/resolveVariables.js'

    import renderPostInstagram from "./renderPost/postInstagram.vue"
    import renderReelInstagram from "./renderPost/reelInstagram.vue"
    import renderPostFacebook from "./renderPost/postFacebook.vue"
    import renderReelFacebook from "./renderPost/reelFacebook.vue"
    import renderPostTwitter from "./renderPost/postTwitter.vue"
    import renderPostLinkedin from "./renderPost/postLinkedin.vue"
    import renderPostTiktok from "./renderPost/postTiktok.vue"
    import renderPostGoogle from "./renderPost/postGoogle.vue"
    import renderPostTelegram from "./renderPost/postTelegram.vue"
    import renderPostPinterest from "./renderPost/postPinterest.vue"
    import renderPostYoutube from "./renderPost/postYoutube.vue"
    import renderShortYoutube from "./renderPost/shortYoutube.vue"
    import renderPostThreads from "./renderPost/postThreads.vue"
    import renderPostBluesky from "./renderPost/postBluesky.vue"

    export default {
        components: {
            renderPostInstagram,
            renderReelInstagram,
            renderPostFacebook,
            renderReelFacebook,
            renderPostTwitter,
            renderPostLinkedin,
            renderPostTiktok,
            renderPostGoogle,
            renderPostTelegram,
            renderPostPinterest,
            renderPostYoutube,
            renderShortYoutube,
            renderPostThreads,
            renderPostBluesky
        },
        props: {
            typeNetworkSelected: String,
            formData: Object,
            formDataPatch: {
                type: Object,
                default: () => ({})
            },
            pages: Array,
            idsPagesStatusEdited: {
                type: Array,
                default: () => ([])
            },
            featuredPageId: {
                type: String,
                default: null
            },
            files: Object,
            positionFormOverlay: {
                type: String,
                default: 'left'
            },
            modes: {
                type: Array,
                default: () => ([])
            }
        },
        methods: {
            clickPageInRenderPost(pageId) {
                this.$emit('clickPageInRenderPost', pageId)
            },
            featurePageInRenderPost(pageId) {
                this.$emit('featurePageInRenderPost', pageId)
            }
        },
        computed: {
            filesNetwork() {
                console.log("computed filesNetwork")
                let formDataNetwork
                if (this.formDataPatch.formDataNetwork && this.formDataPatch.formDataNetwork[this.typeNetworkSelected]) {
                    formDataNetwork = JSON.parse(JSON.stringify(this.formData.formDataNetwork[this.typeNetworkSelected]))
                    mergeUpdates(formDataNetwork, this.formDataPatch.formDataNetwork[this.typeNetworkSelected])
                }else{
                    formDataNetwork = this.formData.formDataNetwork[this.typeNetworkSelected]
                }
                console.log("computed filesNetwork",JSON.parse(JSON.stringify(this.formDataPatch.files || this.formData.files)))
                //getFilesByNetwork(files, networkCheck, formDataNetworks, files)
                const test = getFilesByNetwork(
                    this.formDataPatch.files || this.formData.files, 
                    [this.typeNetworkSelected], 
                    {
                        [this.typeNetworkSelected] : formDataNetwork
                    },
                    this.files
                )[this.typeNetworkSelected]
                console.log("computed filesNetwork test",test)
                return test

            },

            // Pages réordonnées pour que la page mise en avant (choisie par l'utilisateur via
            // featuredPageId, sinon la règle par défaut) tombe au DERNIER INDEX DE LA TRANCHE
            // VISIBLE - donc dans la tranche visible ET au-dessus de la pile visuellement (cf.
            // featuredPage). Important : ce n'est PAS forcément le dernier index du tableau
            // complet - avec plus de 4 pages (sliceCount == 3), pousser en toute fin du tableau
            // la ferait sortir de la tranche visible (elle deviendrait masquée sous "+N" au lieu
            // d'être mise en avant). Ce réordonnancement est local à l'aperçu : il ne touche
            // jamais l'ordre global de pagesSelected (frise, onglets par page, etc.).
            pagesReordered() {
                const featured = getFeaturedPage(this.pages, this.featuredPageId)
                if (!featured) return this.pages

                const idx = this.pages.findIndex(p => p.id === featured.id)
                if (idx === -1) return this.pages

                const sliceCount = this.pages.length === 4 ? 4 : 3
                const targetIndex = Math.min(sliceCount, this.pages.length) - 1
                if (idx === targetIndex) return this.pages

                const reordered = this.pages.slice()
                const [page] = reordered.splice(idx, 1)
                reordered.splice(targetIndex, 0, page)
                return reordered
            },

            pagesEdited() {
                return this.pagesReordered.map(page => ({
                    ...page,
                    iconEdited: this.idsPagesStatusEdited.includes(page.id)
                }))
            },

            // La page "en avant" dans l'aperçu : en mode preview/personnalisation single-page
            // c'est simplement l'unique page ; en vue générale avec plusieurs pages du même
            // réseau, c'est celle affichée au-dessus de la pile d'avatars (même règle de
            // tranche que tous les renderPost/post*.vue : pages.slice(0, length==4 ? 4 : 3),
            // le dernier élément de cette tranche étant rendu par-dessus les autres, donc le
            // seul affiché en cercle complet, non chevauché). pagesReordered ayant déjà placé
            // la page choisie en dernier, la règle par défaut suffit ici.
            featuredPage() {
                return getFeaturedPage(this.pagesReordered, null)
            },

            previewedPageVariables() {
                if (!this.featuredPage) return null
                return this.$store.getters['variables/getVariablesForPage'](this.featuredPage.id)
            },

            textContentConverted() {
                const textContent = this.formDataPatch.hasOwnProperty('textContent') ? this.formDataPatch.textContent : this.formData.textContent

                const regex = /^(<br\s*\/?>|\\n|\s*)+$/i
                if (!textContent || regex.test(textContent)) return ''

                const resolved = this.previewedPageVariables ? resolveVariables(textContent, this.previewedPageVariables) : textContent
                return resolved.replaceAll("\\n", '<br>')
            },

            commentsConverted() {
                let comments = this.formDataPatch.comments || this.formData.comments

                //si il est question que de saut de ligne
                const regex = /^(<br\s*\/?>|\\n|\s*)+$/i

                if (!comments || !comments.length || !comments.some(comment => !regex.test(comment))) return []

                return comments.reduce((acc, comment) => {
                    if (comment && !regex.test(comment)) {
                        const resolved = this.previewedPageVariables ? resolveVariables(comment, this.previewedPageVariables) : comment
                        acc.push(resolved.replaceAll("\\n", '<br>'))
                    }
                    return acc
                },[])
            },

            datePost() {
                const planifiedDate = this.formDataPatch.hasOwnProperty('planifiedDate') ? this.formDataPatch.planifiedDate : this.formData.planifiedDate
                return planifiedDate && planifiedDate.timestamp ? planifiedDate.timestamp : false
            },
            
            snippet() {


                switch (this.typeNetworkSelected) {
                    case 'threads':
                        if (this.filesNetwork.length) return {}
                        if (this.formDataPatch.hasOwnProperty('textContent')) {
                            if (this.formDataPatch.urlsTextContent && this.formDataPatch.urlsTextContent.length) {         
                                return {link: this.formDataPatch.urlsTextContent[0]} 
                            }
                            this.formDataPatch.urlsTextContent && this.formDataPatch.urlsTextContent.length
                        }else{
                            if (this.formData.urlsTextContent && this.formData.urlsTextContent.length) {
                                return {link: this.formData.urlsTextContent[0]}          
                            }
                        }
                        break;
                
                    case 'telegram':
                        if (this.formDataPatch.hasOwnProperty('textContent')) {
                            if (this.formDataPatch.urlsTextContent && this.formDataPatch.urlsTextContent.length) {         
                                return {link: this.formDataPatch.urlsTextContent[0]} 
                            }
                            this.formDataPatch.urlsTextContent && this.formDataPatch.urlsTextContent.length
                        }else{
                            if (this.formData.urlsTextContent && this.formData.urlsTextContent.length) {
                                return {link: this.formData.urlsTextContent[0]}          
                            }
                        }
                        return undefined
                        break;
                
                }
            
                if (
                    this.formDataPatch.formDataNetwork && 
                    this.formDataPatch.formDataNetwork[this.typeNetworkSelected] && 
                    this.formDataPatch.formDataNetwork[this.typeNetworkSelected].snippet && 
                    this.formDataPatch.formDataNetwork[this.typeNetworkSelected].snippet.link
                ) {
                    return this.formDataPatch.formDataNetwork[this.typeNetworkSelected].snippet
                }

                if (
                    this.formData.formDataNetwork && 
                    this.formData.formDataNetwork[this.typeNetworkSelected] && 
                    this.formData.formDataNetwork[this.typeNetworkSelected].snippet && 
                    this.formData.formDataNetwork[this.typeNetworkSelected].snippet.link
                ) {
                    return this.formData.formDataNetwork[this.typeNetworkSelected].snippet
                }

                switch (this.typeNetworkSelected) {
                    case 'twitter':
                        if (this.formDataPatch.hasOwnProperty('textContent')) {
                            if (this.formDataPatch.urlsTextContent && this.formDataPatch.urlsTextContent.length) {         
                                return {link: this.formDataPatch.urlsTextContent[this.formDataPatch.urlsTextContent.length -1]} 
                            }
                            this.formDataPatch.urlsTextContent && this.formDataPatch.urlsTextContent.length
                        }else{
                            if (this.formData.urlsTextContent && this.formData.urlsTextContent.length) {
                                return {link: this.formData.urlsTextContent[this.formData.urlsTextContent.length -1]}          
                            }
                        }
                        
                        break
                }
              
            
                return undefined
            },

            mentions() {
                return {
                    ...(this.formData.mentions ? this.formData.mentions : {}),
                    ...(this.formDataPatch.mentions ? this.formDataPatch.mentions : {})
                }
            },

            place() {
                if (
                    this.formDataPatch.formDataNetwork &&
                    this.formDataPatch.formDataNetwork[this.typeNetworkSelected] && 
                    this.formDataPatch.formDataNetwork[this.typeNetworkSelected].place
                ) return this.formDataPatch.formDataNetwork[this.typeNetworkSelected].place

                if (
                    this.formData.formDataNetwork &&
                    this.formData.formDataNetwork[this.typeNetworkSelected] && 
                    this.formData.formDataNetwork[this.typeNetworkSelected].place
                ) return this.formData.formDataNetwork[this.typeNetworkSelected].place

                return undefined
            },

            personsIdentified() {
                if (this.typeNetworkSelected !== 'instagram') return []
                if (
                    this.formDataPatch.formDataNetwork &&
                    this.formDataPatch.formDataNetwork[this.typeNetworkSelected] && 
                    this.formDataPatch.formDataNetwork[this.typeNetworkSelected].personsIdentified
                ) return this.formDataPatch.formDataNetwork[this.typeNetworkSelected].personsIdentified

                if (
                    this.formData.formDataNetwork &&
                    this.formData.formDataNetwork[this.typeNetworkSelected] && 
                    this.formData.formDataNetwork[this.typeNetworkSelected].personsIdentified
                ) return this.formData.formDataNetwork[this.typeNetworkSelected].personsIdentified

                return []
            },

            collaborators() {
                if (this.typeNetworkSelected !== 'instagram') return []

                if (
                    this.formDataPatch.formDataNetwork &&
                    this.formDataPatch.formDataNetwork[this.typeNetworkSelected] && 
                    this.formDataPatch.formDataNetwork[this.typeNetworkSelected].collaborators
                ) return this.formDataPatch.formDataNetwork[this.typeNetworkSelected].collaborators

                if (
                    this.formData.formDataNetwork &&
                    this.formData.formDataNetwork[this.typeNetworkSelected] && 
                    this.formData.formDataNetwork[this.typeNetworkSelected].collaborators
                ) return this.formData.formDataNetwork[this.typeNetworkSelected].collaborators

                return []
            },

            music() {
                if (this.typeNetworkSelected !== 'instagram' && this.typeNetworkSelected !== 'tiktok') return undefined

                if (
                    this.formDataPatch.formDataNetwork &&
                    this.formDataPatch.formDataNetwork[this.typeNetworkSelected] && 
                    this.formDataPatch.formDataNetwork[this.typeNetworkSelected].music
                ) return this.formDataPatch.formDataNetwork[this.typeNetworkSelected].music

                if (
                    this.formData.formDataNetwork &&
                    this.formData.formDataNetwork[this.typeNetworkSelected] && 
                    this.formData.formDataNetwork[this.typeNetworkSelected].music
                ) return this.formData.formDataNetwork[this.typeNetworkSelected].music

                return undefined
            },

            products() {
                if (this.typeNetworkSelected !== 'instagram') return undefined

                if (
                    this.formDataPatch.formDataNetwork &&
                    this.formDataPatch.formDataNetwork[this.typeNetworkSelected] && 
                    this.formDataPatch.formDataNetwork[this.typeNetworkSelected].products
                ) return this.formDataPatch.formDataNetwork[this.typeNetworkSelected].products

                if (
                    this.formData.formDataNetwork &&
                    this.formData.formDataNetwork[this.typeNetworkSelected] && 
                    this.formData.formDataNetwork[this.typeNetworkSelected].products
                ) return this.formData.formDataNetwork[this.typeNetworkSelected].products

                return undefined
            },

            ratio() {

                if (this.typeNetworkSelected !== 'instagram') return undefined

                if (
                    this.formDataPatch.formDataNetwork &&
                    this.formDataPatch.formDataNetwork[this.typeNetworkSelected] && 
                    this.formDataPatch.formDataNetwork[this.typeNetworkSelected].ratio
                ) return this.formDataPatch.formDataNetwork[this.typeNetworkSelected].ratio

                if (
                    this.formData.formDataNetwork &&
                    this.formData.formDataNetwork[this.typeNetworkSelected] && 
                    this.formData.formDataNetwork[this.typeNetworkSelected].ratio
                ) return this.formData.formDataNetwork[this.typeNetworkSelected].ratio

                return undefined
            },

            survey() {

                if (this.typeNetworkSelected !== 'linkedin') return null

                if (
                    this.formDataPatch.formDataNetwork &&
                    this.formDataPatch.formDataNetwork[this.typeNetworkSelected] && 
                    this.formDataPatch.formDataNetwork[this.typeNetworkSelected].survey
                ) {
                    return this.formDataPatch.formDataNetwork[this.typeNetworkSelected].survey.active ? this.formDataPatch.formDataNetwork[this.typeNetworkSelected].survey : null
                }

                if (
                    this.formData.formDataNetwork &&
                    this.formData.formDataNetwork[this.typeNetworkSelected] && 
                    this.formData.formDataNetwork[this.typeNetworkSelected].survey
                ) {
                    return this.formData.formDataNetwork[this.typeNetworkSelected].survey.active ? this.formData.formDataNetwork[this.typeNetworkSelected].survey : null
                }

                return undefined
            },

        },

        watch: {
            'formData.files': {
                immediate: false,
                deep: false,
                handler(newValue, oldValue) {
                    console.log("this.formData.files changed",newValue)
                }
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>
